import { Theme } from "@radix-ui/themes"
import { NuqsAdapter } from "nuqs/adapters/react-router/v7"
import { Outlet } from "react-router"
import type { Route } from "./+types/root"
import { fspConfig } from "./init/fsp-config"
import { DateTimeUtilsProvider } from "./shared/date-time-utils-context"
import { LangProvider } from "./shared/lang-context"

export default function Root({ loaderData: ld }: Route.ComponentProps) {
  const { font, headingFont } = fspConfig

  return (
    <NuqsAdapter>
      <LangProvider>
        <DateTimeUtilsProvider appTime={ld.appTime}>
          {/* This div must wrap <Theme>: the data-font / data-heading-font attributes
              feed Radix's font tokens via descendant selectors, see font-settings.css */}
          <div
            id="root"
            className="min-h-screen bg-gray-100 text-gray-900 antialiased"
            data-font={font}
            data-heading-font={headingFont}
          >
            <Theme radius="medium" hasBackground={true} accentColor={fspConfig.pColor}>
              <Outlet />
            </Theme>
          </div>
        </DateTimeUtilsProvider>
        {/* TODO: fix this, SSR */}
        {/* <Fathom /> */}
        {/* TODO: fix this, SSR */}
        {/* <Sentry.ErrorBoundary fallback={SentryFallback} showDialog> */}
        {/* {children} */}
        {/* </Sentry.ErrorBoundary> */}
      </LangProvider>
    </NuqsAdapter>
  )
}

/**
 * Straight from the React docs:
 * Error boundaries are React components that catch JavaScript errors anywhere in their child component tree,
 * log those errors, and display a fallback UI instead of the component tree that crashed.
 *
 * This means the RQ Devtools will no longer be visible since they are a part of the Footer component
 * in App.js because if this error boundary has been activated that whole component tree has been unmounted.
 * So the fallback UI we choose to return here should display the RQ Devtools. It's ok if the user sees them
 * since our restaurant users are sort of power users.
 */
function SentryFallback() {
  return <p>Error</p>
}
